// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3TU5X","toggle":"styles_toggle__3YZSC","preview":"styles_preview__160VV"};